/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {ViolationDefinition} from "../model/ViolationDefinition";
import {HttpClient, HttpHeaders} from "@angular/common/http";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class ViolationDefinitionService {

  private readonly sitesUrl: string;

  constructor(private http: HttpClient) {
    this.sitesUrl = inject(APP_CONFIG).baseUrl + '/api/violationdefinitions';
  }

  getAll(): Observable<ViolationDefinition[]> {
    const url = `${this.sitesUrl}/all`;
    return this.http.get(url, httpOptions).pipe(
      map(violation => violation as ViolationDefinition[]));
  }

  getSorted(): Observable<ViolationDefinition[]> {
    const url = `${this.sitesUrl}/customsorted`;
    return this.http.get(url, httpOptions).pipe(
      map(violation => violation as ViolationDefinition[]));
  }

  addNewViolationDefinition(newViolationDefinition: ViolationDefinition): Observable<ViolationDefinition> {
    const url = `${this.sitesUrl}`;
    return this.http.post(url, newViolationDefinition, httpOptions).pipe(
      map( newViolationDefinition => newViolationDefinition as ViolationDefinition ));
  }

  updateViolationDefinition(violationDefinition: ViolationDefinition): Observable<ViolationDefinition> {
    var url = `${this.sitesUrl}/${violationDefinition.violationDefinitionId}`;
    return this.http.put(url, violationDefinition, httpOptions).pipe(
      map( violationDefinition => violationDefinition as ViolationDefinition ));
  }

}
